import React from 'react'
import { Link } from 'gatsby-plugin-intl';
import { getCurrentLangKey } from '../../utils/getCurrentLangKey';
import { getLinkPrefix } from '../../utils/getLinkPrefix';

export const BreadCrumbBlock = props => {
  const langKey = getCurrentLangKey();
  const country_code = props.country_code ? props.country_code : "us";
  return (
    <div className="container">
      <div className="row">
        <div className="col-sm-12 hidden-xs">
          <ol className="breadcrumb">
            <li>
              <Link to={`/${country_code}`} language={langKey} title="Support Hub">
                Support Hub
              </Link>
            </li>
            {/* Categories, may need to adjust later */}
            {props.categories?.length ? <li><Link to={getLinkPrefix('categories', `${props.categories[0]?.link}`)} language={langKey}>{props.categories[0]?.Name}</Link></li> : null}

            {/* Sub categories, may need to adjust later */}
            {props.subcategories?.length && props.categories?.length ? <li><Link to={getLinkPrefix('subcategories', `${props.categories[0]?.link}/${props.subcategories[0]?.link}`)} language={langKey}>{props.subcategories[0]?.name}</Link></li> : null}

            <li className="active">{props.label}</li>
          </ol>
        </div>
      </div>
    </div>
  )
}
